'use strict';

import { fh_polygon } from '@acenv/fh-3d-viewer';
import { cn_building } from '../../model/cn_building';
import { cn_scene } from '../../model/cn_scene';
import { cn_storey } from '../../model/cn_storey';
import { cn_vertex } from '../../model/cn_vertex';
import { CN_MIDDLE, cn_wall } from '../../model/cn_wall';
import { cn_wall_type } from '../../model/cn_wall_type';
import { cn_add, cn_box, cn_dist, cn_dot, cn_intersect_line, cn_middle, cn_mul, cn_normal, cn_normalize, cn_size, cn_sub, cnx_clone } from '../cn_utilities';
import { cn_opening_type } from '../../model/cn_opening_type';
import { cn_opening } from '../../model/cn_opening';
import { cn_material } from '../../model/cn_material';
import { logger } from '../cn_logger';
import { CODES_BIM_OUVRAGES } from '../cn_bbp_constants';

//***********************************************************************************
//***********************************************************************************
//**** WISEBIM importer
//***********************************************************************************
//***********************************************************************************

export function cn_read_bbp(bbp_file) {
    var reader = new cn_bbp_reader();
    reader.parse(bbp_file);
    return reader._building;
}

export class cn_bbp_reader {
    constructor() {
        this._building = null;
    }

    //***********************************************************************************
    //**** Main function
    //***********************************************************************************
    parse(bbp_file) {
        this._building = new cn_building();
        this._building.storeys = [];
        this._wall_types = [];

        const storeys_names = [];
        bbp_file.storey_list.forEach(s => {
            const storey = new cn_storey(this._building);
            storey.storey_index = this._building.storeys.length;
            storeys_names.push(storey.storey_index.toFixed(0));
            this._building.storeys.push(storey);
        });

        bbp_file.objects.filter(bbp_object => bbp_object.Code_BIM == CODES_BIM_OUVRAGES.wall).forEach(bbp_object => {
            storeys_names.forEach((stn, storey_index) => {
                const footprint = new fh_polygon([0, 0, 0], [0, 0, 1]);

                bbp_object.geometries.filter(geom => geom.views.includes(stn)).forEach(geom => {
                    const vertices = [];
                    for (var k = 0; k < geom.vertices.length; k += 3) {
                        vertices.push([geom.vertices[k], geom.vertices[k + 1], 0]);
                    }
                    for (var k = 0; k < geom.triangles.length; k += 3) {
                        footprint.add_contour([vertices[geom.triangles[k]], vertices[geom.triangles[k + 1]], vertices[geom.triangles[k + 2]]]);
                    }
                });

                const storey = this._building.storeys[storey_index];
                if (footprint.get_area() > 0)
                    this._analyse_footprint(footprint, storey.scene);
            });
        });

        this._building.storeys.forEach(storey => storey.scene.scene_analyser.process());
    }

    /**
     *
     * @param {fh_polygon} footprint
     * @param {cn_scene} scene
     * @returns
     */
    _analyse_footprint(footprint, scene) {
        let max_length = 0;
        let direction = [];
        let offset = 0;
        footprint.contour_sizes.forEach(sz => {
            for (var n = 0; n < sz; n++) {
                const dir = cn_sub(footprint.contour_vertices[offset + ((n + 1) % sz)], footprint.contour_vertices[offset + n]);
                const l = cn_normalize(dir);
                if (l > max_length) {
                    max_length = l;
                    direction = dir;
                }
            }
            offset += sz;
        })
        if (!direction.length) return;
        const dy = cn_normal(direction);
        const box = new cn_box();
        footprint.contour_vertices.forEach(v => {
            const d = cn_sub(v, footprint.contour_vertices[0]);
            box.enlarge_point([cn_dot(d, direction), cn_dot(d, dy)]);
        });
        const c0 = [box.posmin[0], box.posmin[1] + 0.5 * box.size[1]];
        const c1 = [box.posmin[0] + box.size[0], box.posmin[1] + 0.5 * box.size[1]];
        const p0 = cn_add(footprint.contour_vertices[0], cn_add(cn_mul(direction, c0[0]), cn_mul(dy, c0[1])));
        const p1 = cn_add(footprint.contour_vertices[0], cn_add(cn_mul(direction, c1[0]), cn_mul(dy, c1[1])));

        let v0 = scene.find_vertex(p0, 0.01) || new cn_vertex(p0, false, scene);
        let v1 = scene.find_vertex(p1, 0.01) || new cn_vertex(p1, false, scene);

        if (!v0["initial_position"]) v0["initial_position"] = p0;
        if (!v1["initial_position"]) v1["initial_position"] = p1;
        const thickness = box.size[1];

        var wall_type = this._wall_types.find(wt => Math.abs(wt.thickness - thickness) < 0.005);
        if (!wall_type) {
            wall_type = new cn_wall_type();
            wall_type.name = 'Mur ' + (0.1 * Math.round(thickness * 1000)).toFixed(1) + 'cm';
            // TODO Quel parent passer ici ?
            wall_type.layers = [cn_material.material_by_code(null, 'unknown', thickness)];
            this._building.element_types.push(wall_type);
            this._wall_types.push(wall_type);
        }

        const w = new cn_wall(v0, v1, wall_type, CN_MIDDLE, scene);
        scene.insert_wall(w, null);
    }
}


